import {
    FETCH_DELETEATTACHMENT_FULFILLED,
    FETCH_DELETEATTACHMENT_REJECTED,
    FETCH_DELETEATTACHMENT_PENDING,
    RESET_ATTACHMENT,
  } from "../../actions/attachment/deleteAttachment";
  const initialState = {
    done: false,
    error: false,
    spinner: false
  };
  
  export default (state = initialState, action) => {
  
    switch (action.type) {
  
      case FETCH_DELETEATTACHMENT_PENDING:
        return {
          done: false,
          error: false,
          spinner: true,
        };
      case FETCH_DELETEATTACHMENT_FULFILLED:
        return {
          ...state,
          deleteAttachment: action.payload,
          done: true,
          error: false,
          spinner: false
        };
      case FETCH_DELETEATTACHMENT_REJECTED:
        return {
          ...state,
          error: action.payload,
          done: false,
          spinner: false
        };
      case RESET_ATTACHMENT:
        return {
          initialState,
          done: false,
          error: false,
          spinner: false
        };
      default:
        return state;
    }
  };